import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

import { largeScreen } from "src/shared/constants/screenSizes";
import UIAvatar from "src/shared/contact-boxes/components/Avatar";

import { DealDetails } from "../DealDetails/styled";

export const ProfileDetails = styled.div`
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 10px;
  text-align: center;
`;

export const Avatar = styled(UIAvatar)`
  height: 100px;
  margin: 0 0 10px 0;
  max-height: 100px;
  max-width: 100px;
  width: 100px;

  @media screen and (min-width: ${largeScreen}px) {
    max-height: auto;
    max-width: auto;
  }
`;

export const NameLink = styled.a`
  color: ${colors.primary};
  display: block;
  font-size: 20px;
  font-weight: 100;
  height: 32px;
  line-height: 32px;
  text-decoration: none;
`;

export const InformationSection = styled.section`
  text-align: center;

  @media screen and (max-width: ${largeScreen}px) {
    text-align: left;
    margin-left: 20px;

    ${ProfileDetails}, ${DealDetails} * {
      text-align: left;
    }
  }
`;
